export const CORPORATE_SESSION_STORAGE_KEY = "mirum_isCorporate";
export const CORPORATE_QUERY_PARAM = "isCorporate";

const EXIT_EVENT = "mirum-corporate-exit";

export function readCorporateSessionFlag() {
  return sessionStorage.getItem(CORPORATE_SESSION_STORAGE_KEY) === "true";
}

export function writeCorporateSessionFlag(on) {
  if (on) {
    sessionStorage.setItem(CORPORATE_SESSION_STORAGE_KEY, "true");
  } else {
    sessionStorage.removeItem(CORPORATE_SESSION_STORAGE_KEY);
  }
}

export function clearCorporateSessionAndNotify() {
  sessionStorage.removeItem(CORPORATE_SESSION_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(EXIT_EVENT));
}

export function subscribeCorporateExit(callback) {
  window.addEventListener(EXIT_EVENT, callback);
  return () => window.removeEventListener(EXIT_EVENT, callback);
}
